var render = function render(){var _vm=this,_c=_vm._self._c;return _c('codemirror',{ref:"editor",staticStyle:{"width":"100%"},attrs:{"value":_vm.value || '',"options":{..._vm.cmOptions, readOnly: _vm.readonly}},on:{"input":function($event){return _vm.$emit('input', $event)},"focus":function($event){return _vm.refreshEditor()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }